var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mainScrollCont)?_c('top-bar'):_vm._e(),_c('div',{ref:"mainContainer",staticClass:"container--scrollable"},[_vm._t("default")],2),_c('main-navigation',{attrs:{"menu-items":_vm.mainMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }